import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SDrawerOrModal,
  SFuncModalFormRef,
  SLowcodeList, SMessage,
  STableActions,
} from 'shj-components'
import {
  getRegionLists,
  getDispatchMnrPage,
  getBizOpTypeEnum,
  delDispatchStore,
} from '@/services/customerServices'
import { httpOrgList } from '@/services/homeService.ts'
import { useSetState } from 'ahooks'
import { message } from 'antd'
import { config } from './config'
import AddOrEditForm from './addOrEdit'
import {getChannelBrandAgent} from "@/services/getUsers.ts";

const StoreManagement: React.FC = () => {
  const [state, setState] = useSetState({
    treeData: [], // 左侧树形结构数据
    companyList: [], // 门店
    regionList: [], // 门店
    BizOpTypeEnumList: [], //需求标签
    brandList: [], //品牌
  })
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [editData, setEditData] = useState(null)
  const [btnLoading, setBtnLoading] = useState(false)
  const editRef = useRef<SFuncModalFormRef>({ onFinish: undefined })
  const listRef = useRef<any>()
  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    rest.query.searchFlag = true
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getDispatchMnrPage(current, pageSize, rest.query)
        resolve(data)
      } catch (err) {
        reject({ success: false })
      }
    })
  }
  //   右侧下拉选项加载
  const getOptions = async () => {
    const companyList: any = await httpOrgList({})
    const regionList = await getRegionLists()
    const BizOpTypeEnumList: any = await getBizOpTypeEnum()
    const brandList: any = await getChannelBrandAgent()
    setState({ companyList, regionList, BizOpTypeEnumList, brandList })
    return Promise.resolve({ companyList, regionList, BizOpTypeEnumList, brandList })
  }
  // 右侧表格事件：
  // 新增
  const onAdd = async () => {
    setEditData(null)
    setDrawerVisible(true)
  }
  // 刷新
  const reloadFn = () => {
    listRef.current?.reload()
  }

  //  表格事件: 编辑
  const onEdit = data => {
    setEditData(data)
    setDrawerVisible(true)
  }
  //  抽屉事件: 保存
  const onSubmit = val => {
    editRef.current.onFinish?.()
  }

  const onDel = (record) => {
    SMessage.confirm({
      onOk: () => {
        return delDispatchStore(record.id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList, getOptions },
    events: {
      onAdd,
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn danger onClick={() => onDel(record)}>删除</SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return (
    <div>
      {/* 右侧数据表格 */}
      <div>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </div>
      {/* 新增弹出抽屉层 */}
      <SDrawerOrModal
        title={editData ? '编辑派门店规则' : '新增派门店规则'}
        width={500}
        mode="modal"
        open={drawerVisible}
        onCancel={() => {
          setBtnLoading(false)
          setDrawerVisible(false)
        }}
        onOk={onSubmit}
        loading={btnLoading}
      >
        {drawerVisible && (
          <AddOrEditForm
            editRef={editRef.current}
            editData={editData}
            fn={listRef.current?.reload}
            onCancel={() => {
              setBtnLoading(false)
              setDrawerVisible(false)
            }}
            state={state}
            setBtnLoading={val => {
              setBtnLoading(val)
            }}
          />
        )}
      </SDrawerOrModal>
    </div>
  )
}

export default props => {
  return <StoreManagement {...props} />
}
